import $ from 'jquery'
import {join, map} from 'lodash'
import 'parsleyjs'

function init() {
  if ($('form').length === 0) {
    return
  }
  $('form').parsley({
    errorClass: 'invalid',
    successClass: 'valid',
    validationThreshold: 2,
    errorsContainer: function(parsleyField) {
      const errorsContainer = $('<div>')
      .addClass('js-error-container')
      .addClass('hide')
      parsleyField.$element.parent().prepend(errorsContainer)
      return errorsContainer
    }
  })

  $('body').on('change', 'form select', evt => {
    $(evt.target).parsley().validate()
  })
  $('body').on('change', 'form input[type="radio"]', evt => {
    $(evt.target).parsley().validate()
  })

  window.Parsley.on('field:success', function(parsleyField) {
    const tagName = parsleyField.$element.prop('tagName')
    const type = parsleyField.$element.attr('type')

    if (tagName === 'SELECT') {
      const parsleyId = parsleyField.$element.data('parsley-id')
      parsleyField.$element.siblings().remove('.js-error-container')
      $(`div`).remove(`.js-validation-error-message[data-parsley-id="${parsleyId}"]`)
    } else if (tagName === 'INPUT' && type && type.toLowerCase() === 'radio') {
      const name = parsleyField.$element.attr('name')

      $(`div`).remove(`.js-validation-error-message[data-parsley-id-multiple="${name}"]`)
    } else {
      const id = parsleyField.$element.attr('id')
      const label = $(`label[for="${id}"]`)

      label.removeAttr('data-error')
    }
  })

  window.Parsley.on('field:error', function(parsleyField) {
    const tagName = parsleyField.$element.prop('tagName')
    const type = parsleyField.$element.attr('type')

    const parsleyId = parsleyField.$element.data('parsley-id')
    const errorsList = $(`ul#parsley-id-${parsleyId}`)
    const errors = map(errorsList.find('li'), li => li.textContent)
    const errorsJoined = join(errors, ' ')

    if (tagName === 'SELECT') {
      const errorMessage = $('<div>')
        .addClass('js-validation-error-message')
        .attr('data-parsley-id', parsleyId)
        .text(errorsJoined)
      $(`div`).remove(`.js-validation-error-message[data-parsley-id="${parsleyId}"]`)
      parsleyField.$element.after(errorMessage)
      $('html, body').scrollTop(parsleyField.$element.siblings('input').offset().top - 300)
    } else if (tagName === 'INPUT' && type && type.toLowerCase() === 'radio') {
      const name = parsleyField.$element.attr('name')
      const errorsListRadio = $(`ul#parsley-id-multiple-${name}`)
      const errorsRadio = map(errorsListRadio.find('li'), li => li.textContent)
      const errorsJoinedRadio = join(errorsRadio, ' ')

      const radioHolderDiv = $(`div.invalid:has(input[name="${name}"])`)
      const errorMessage = $('<div>')
        .addClass('js-validation-error-message')
        .attr('data-parsley-id-multiple', name)
        .text(errorsJoinedRadio)
      $(`div`).remove(`.js-validation-error-message[data-parsley-id-multiple="${name}"]`)
      radioHolderDiv.before(errorMessage)
    } else {
      const id = parsleyField.$element.attr('id')
      const label = $(`label[for="${id}"]`)

      label.addClass('active')
      label.attr('data-error', errorsJoined)
    }
  })
}

module.exports.init = init



// WEBPACK FOOTER //
// ./src/parsley-materialize.js